// Template208: Osaka - Mapa Día 1 (Castillo y Shinsekai)
// Equivalente a Page8.jsx de guia-osaka. Iframe Google Maps + Umeda Sky Building.

import React, { useState } from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const MAP_EMBED_URL =
	"https://www.google.com/maps/d/embed?mid=1m1fIq4dYmA1HS__eFGI72WS9BerOc1g&ehbc=2E312F";

const Template208 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;
	const [fullscreen, setFullscreen] = useState(false);

	const headerText = page?.texts?.[0]?.content;
	const tipMetro = page?.texts?.[1]?.content;
	const umedaTitle = page?.texts?.[2]?.content;
	const umedaBody = page?.texts?.[3]?.content;
	const umedaEntrada = page?.texts?.[4]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const metroImage = getImageSrc("metro");
	const mapOfflineImage = getImageSrc("mapa");
	const logoImage = getCanvasImageUrl("logo");

	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];

	const actualHeaderColor = headerBackgroundColor || "#1F4E3D";
	const mapUrl = page?.maps?.[0] || MAP_EMBED_URL;

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#000",
		margin: 0,
	};

	if (fullscreen) {
		return (
			<div
				style={{
					position: "fixed",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					backgroundColor: "#fff",
					zIndex: 9999,
					display: "flex",
					flexDirection: "column",
				}}
			>
				<div
					style={{
						padding: "10px",
						textAlign: "right",
						backgroundColor: actualHeaderColor,
					}}
				>
					<button
						onClick={() => setFullscreen(false)}
						style={{
							backgroundColor: "#fff",
							color: actualHeaderColor,
							border: "none",
							borderRadius: "8px",
							padding: "6px 12px",
							fontWeight: 600,
							cursor: "pointer",
							fontFamily: "'Poppins', sans-serif",
						}}
					>
						← Volver a la guía
					</button>
				</div>
				<iframe
					title="Mapa grande"
					src={mapUrl}
					width="100%"
					height="100%"
					style={{ border: 0, flex: 1 }}
					allowFullScreen
					loading="lazy"
				/>
			</div>
		);
	}

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				height: "100%",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					zIndex: 2,
					position: "relative",
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box
				data-block-id="map"
				sx={{
					flex: 1,
					marginTop: "-70px",
					position: "relative",
					minHeight: 280,
				}}
			>
				<button
					onClick={() => setFullscreen(true)}
					style={{
						position: "absolute",
						top: 80,
						right: 10,
						backgroundColor: actualHeaderColor,
						color: "#fff",
						padding: "8px 10px",
						fontSize: "11px",
						borderRadius: "8px",
						fontFamily: "'Poppins', sans-serif",
						boxShadow: "1px 1px 2px rgba(0,0,0,0.2)",
						zIndex: 4,
						border: "none",
						cursor: "pointer",
					}}
				>
					Ver mapa grande
				</button>

				<iframe
					title="Mapa Día 1"
					src={mapUrl}
					width="100%"
					height="100%"
					style={{ border: 0, minHeight: 280 }}
					loading="lazy"
				/>

				{metroImage && (
					<Box
						component="img"
						src={metroImage}
						alt="Metro"
						sx={{
							width: 90,
							position: "absolute",
							bottom: -10,
							left: -18,
						}}
					/>
				)}

				{tipMetro && (
					<Box
						sx={{
							position: "absolute",
							bottom: 50,
							left: 50,
							backgroundColor: "#fff8db",
							border: "2px solid #f5c400",
							borderRadius: "16px 16px 16px 0px",
							padding: "10px 12px",
							fontSize: 11,
							color: "#444",
							boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
							maxWidth: 200,
						}}
					>
						{tipMetro}
					</Box>
				)}
			</Box>

			<Box
				data-block-id="text-1"
				sx={{
					padding: "12px 16px",
					fontSize: 12,
					backgroundColor: "#fff",
					color: "#333",
					marginTop: 1.5,
				}}
			>
				<Box
					sx={{
						display: "flex",
						gap: 2,
						position: "relative",
						marginBottom: 2.5,
					}}
				>
					{sabiasQue.length > 0 && (
						<>
							<Box
								sx={{
									position: "absolute",
									top: isSmallScreen ? -30 : -10,
									left: isSmallScreen ? "63%" : "32%",
								}}
							>
								<SabiasQue
									icono={sabiasQue[0]?.icono ?? "🌃"}
									texto={sabiasQue[0]?.texto ?? ""}
								/>
							</Box>
							{sabiasQue[1] && (
								<Box
									sx={{
										position: "absolute",
										top: isSmallScreen ? -30 : -10,
										left: "52%",
									}}
								>
									<SabiasQue
										icono={sabiasQue[1]?.icono ?? "💡"}
										texto={sabiasQue[1]?.texto ?? ""}
									/>
								</Box>
							)}
						</>
					)}
					<Box sx={{ width: "100%" }}>
						{umedaTitle && (
							<Box component="h3" sx={estiloH3}>
								{umedaTitle}
							</Box>
						)}
						{umedaBody && (
							<Box component="p" sx={estiloP}>
								{umedaBody}
							</Box>
						)}
					</Box>
				</Box>
				{umedaEntrada && (
					<Box
						sx={{
							backgroundColor: "#d1e6de",
							border: "2px solid #1F4E3D",
							borderRadius: "12px",
							padding: "8px 16px",
							fontSize: "13px",
							color: "#444",
							textAlign: "center",
							marginBottom: isSmallScreen ? 1.25 : 0,
						}}
					>
						<Box
							component="p"
							sx={estiloP}
							dangerouslySetInnerHTML={{ __html: umedaEntrada }}
						/>
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template208.thumbnail = "/images/template-1.png";

export default Template208;
